import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "@/store";

import {
  startM365ConnectThunk,
  fetchM365StatusThunk,
  disconnectM365Thunk,
  selectM365ConnectorState,
} from "../store/m365ConnectorSlice";

export function useM365Connector(autoLoad = true) {
  const dispatch = useDispatch<AppDispatch>();
  const state = useSelector((s: RootState) => selectM365ConnectorState(s));

  useEffect(() => {
    if (autoLoad) dispatch(fetchM365StatusThunk());
  }, [autoLoad, dispatch]);

  return {
    ...state,
    refresh: () => dispatch(fetchM365StatusThunk()),
    connect: () => dispatch(startM365ConnectThunk()),
    disconnect: () => dispatch(disconnectM365Thunk()),
  };
}
